import styled from "styled-components";
import {IndicatorIconWrapperDefaultBox} from "./indicator-icon-wrapper-default.box";

export const IndicatorIconWrapper777Box = styled(IndicatorIconWrapperDefaultBox)`
    color: ${({theme, active}) => active ? theme.colors.textLight : theme.colors.brandSecondaryDark };
`;